import React from 'react';
import { History } from 'history';
import BaseShare from '../base/base-share.component';
import Model from './user-model';  //editable..
import UserAuthSendConfirmationEmail from './user-auth-sendconfirmationemail.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserShare extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <>            
            <BaseShare history={this.props.history} buttonCaption=' '
                model={Model} onLoad={this.onLoad} />
                
            <UserAuthSendConfirmationEmail history={this.props.history} caption='Share Confirmation Email' useremail={this.state.datarow.useremail}/>
            </>
        );
    }
}